<script>
    import { onMount, onDestroy } from 'svelte';
    import { datepickerRange, getDateRangeFromPreset, resetFlatpickrDate } from '@lib/datepicker/datepickerRange';
    import { formatDateToKorean } from '@lib/util/dateUtils';
    import Pagination from '@components/Pagination.svelte';
    import { perPageOptions } from '@lib/models/perPageOptions'
    import { datePresetOptions } from '@lib/models/datePresetOptions'

    let isInitialMount = true;          // 초기 mount 여부 확인
    let isCategoryOpen = false;         // 검색 조건 카테고리 선택 드롭다운 열림 여부
    let isDatePresetOpen = false;       // 날짜 프리셋 선택 드롭다운 열림 여부

    let viewCategory = '';              // 사용자에게 표시할 카테고리명 (ex. 상태, 제목 등)
    let viewDataPreset = '';            // 사용자에게 표시할 날짜 프리셋명 (ex. 오늘, 어제 등)

    let categoryDropdownEl = null;      // 카테고리 드롭다운 DOM 요소 참조
    let datePresetDropdownEl = null;    // 날짜 프리셋 드롭다운 DOM 요소 참조
    
    let status = 'all';                 // 초기 선택값
    
    let error = ''; 

    let loading = false;                 // 서비스 이력 데이터 로딩 상태

    let activeTab = 'request';          // request or response

    //let serviceHistories = [];          // API에서 받아온 서비스 이력 목록
    let serviceHistories = [
        {
            status: '에러',
            history_type: 'PDF 변환 요청',
            user_id: 'jlee001',
            user_name: '이준호',
            timestamp: '2025-06-17 09:00:00'
        },
        {
            status: '완료',
            statusText: '완료',
            history_type: '문제 변환 요청',
            user_id: 'kseo1024',
            user_name: '서규진',
            timestamp: '2025-06-17 08:00:00'
        },
        {
            status: '완료',
            statusText: '완료',
            history_type: 'PDF 출력 요청',
            user_id: 'hyunteacher',
            user_name: '현수진',
            timestamp: '2025-06-17 07:30:00'
        },
        {
            status: '완료',
            history_type: 'HWP 출력 요청',
            user_id: 'eduadmin',
            user_name: '김영선',
            timestamp: '2025-06-17 06:20:00'
        },
        {
            status: '완료',
            history_type: 'PDF 출력 요청',
            user_id: 'junteacher',
            userName: '전지현',
            timestamp: '2025-06-17 05:15:00'
        },
        {
            status: '완료',
            history_type: 'HWP 출력 요청',
            user_id: 'testdemo12',
            user_name: '테스트계정',
            timestamp: '2025-06-17 04:00:00'
        },
        {
            status: '에러',
            history_type: 'PDF 출력 요청',
            user_id: 'partner02',
            user_name: '이승훈',
            timestamp: '2025-06-17 03:45:00'
        },
        {
            status: '완료',
            history_type: '문제 변환 요청',
            user_id: 'jlee001',
            user_name: '이준호',
            timestamp: '2025-06-17 03:20:00'
        },
        {
            status: '완료',
            history_type: '문제 변환 요청',
            user_id: 'kseo1024',
            user_name: '서규진',
            timestamp: '2025-06-17 02:10:00'
        }
    ];
    const paramsExample = `{
        "format": "PDF",
        "lang": "ko",
        "template": "default",
        "user_plan": "plan2"
    }`;
    let size = 20;                      // 페이지당 공지사항 수 (기본: 20)
    let total = 0;                      // 전체 개수
    
    let totalPages = 0; 
    let currentPage = 1;

    let startRef = {                    // 시작 날짜 input에 바인딩된 flatpickr 인스턴스 조작용 객체
        onStartChange: (dateStr) => {
            searchParam.startDate = dateStr;
        }
    };

    let endRef = {                      // 종료 날짜 input에 바인딩된 flatpickr 인스턴스 조작용 객체
        onEndChange: (dateStr) => {
            searchParam.endDate = dateStr;
        }
    };

    const filterOptions = [
        { label: '진행 상태', value: 'status' },
        { label: '처리 유형', value: 'history_type' },
        { label: '사용자 ID', value: 'user_id' },
        { label: '사용자 이름', value: 'user_name' },
    ];

    const defaultSearchParam = {
        category: "",
        searchKeyword: "",
        startDate: "",
        endDate: "",
        status: "",
        page: 1,
        size: size
    };

    const statusOptions = [
        { id: 'radio1', label: '전체', value: 'all', checked: true },
        { id: 'radio2', label: '완료', value: '완료', checked: false },
        { id: 'radio3', label: '에러', value: '에러', checked: false }
    ];

    let searchParam = { ...defaultSearchParam }; // 초기값 세팅

    /**
     * @param {number} page
     */
    function handlePageChange(page) {
        currentPage = page;
        searchParam.page = page;
        //fetchNotices(searchParam);
    }

    function searchBoxReset(){
        // searchParam 초기화
        searchParam = { ...defaultSearchParam };

        // UI 관련 리셋 로직 실행
        selectCategory(filterOptions[0]);
        selectDatePreset(datePresetOptions[0]);

        status = 'all';

    }

    function search(){
        //fetchNotices(searchParam);
    }

    /**
     * 날짜 프리셋(오늘, 어제, 이번 주 등)을 선택했을 때 실행되는 핸들러
     *
     * 1. 프리셋에 맞는 날짜 범위 계산
     * 2. UI 및 내부 상태 업데이트 (viewDataPreset, searchParam 등)
     * 3. flatpickr 인스턴스를 통해 실제 input 요소의 날짜 갱신
     *
     * @param {{ label: string, value: string }} datePresetOptions - 선택된 날짜 프리셋 옵션 객체
     */
    async function selectDatePreset(datePresetOptions) {
        const result = getDateRangeFromPreset(datePresetOptions.value);
       
        if (!result) return;


        viewDataPreset = datePresetOptions.label;
        searchParam.startDate = result.startDate;
        searchParam.endDate = result.endDate;
        isDatePresetOpen = false;


        // Date 객체로 변환
        const start = new Date(result.startDate);
        const end = new Date(result.endDate);

        resetFlatpickrDate(startRef.instance, start);
        resetFlatpickrDate(endRef.instance, end);

    }

    /**
     * 카테고리 선택 시 호출됨
     * @param {{ label: any; value: any; }} filterOptions
     */
    function selectCategory(filterOptions) {
        viewCategory = filterOptions.label;
        searchParam.category = filterOptions.value;
        isCategoryOpen = false; // 선택 후 드롭다운 닫기
    }

    // 검색 조건 카테고리 드롭다운 열기/닫기 토글
    function toggleCategoryDropdown() {
        isCategoryOpen = !isCategoryOpen;
    }
    
    // 날짜 프리셋(오늘/이번주 등) 드롭다운 열기/닫기 토글
    function toggleDataPresetDropdown() {
        isDatePresetOpen = !isDatePresetOpen;
    }


    /**
     * 드롭다운 외부 클릭 시 드롭다운을 닫기 위한 이벤트 핸들러
     * @param {{ target: any; }} event 클릭 이벤트 객체
     */
    function handleClickOutside(event) {
        // 통화 드롭다운 외부 클릭 감지
        if (isCategoryOpen && categoryDropdownEl && !categoryDropdownEl.contains(event.target)) {
            isCategoryOpen = false;
        }

        if (isDatePresetOpen && datePresetDropdownEl && !datePresetDropdownEl.contains(event.target)) {
            isDatePresetOpen = false;
        }
    }
    onMount(async () => {
        selectCategory(filterOptions[0]);
        selectDatePreset(datePresetOptions[0]);
        document.addEventListener('click', handleClickOutside);
    });

    onDestroy(() => {
        document.removeEventListener('click', handleClickOutside);
    });
</script>
<div class="service-wrap d-flex flex-column h-100">
    <p class="font-20 font-weight-700">서비스 이력</p>
    <section class="box-gray d-flex align-center mt-5">
        <article class="form-block">
            <form action="" class="d-flex align-center flex-wrap gap-3">
                <fieldset class="width-160">
                    <legend>사용자 관리 input 셀렉트</legend>
                    <div class="custom-select w-100" class:active={isCategoryOpen} bind:this={categoryDropdownEl}>
                         <button type="button" class="custom-select__selected" on:click={toggleCategoryDropdown}>
                            <span>{viewCategory}</span>
                            <i class="icon icon-dropdown"></i>
                        </button>
                        <ul class="custom-select__options">
                            {#each filterOptions as option}
                            <li class="custom-select__option">
                                <button
                                    type="button"
                                    class="custom-select__button"
                                    on:click={() => selectCategory(option)}
                                    >
                                    {option.label}
                                </button>
                            </li>
                            {/each}
                        </ul>
                    </div>
                </fieldset>
                <fieldset class="width-200">
                    <legend>사용자 관리 input 텍스트</legend>
                    <label for="input-field-notice">
                        <input 
                            type="text" 
                            name="" 
                            id="input-field-notice" 
                            class="input-field" 
                            title="notice input 텍스트" 
                            placeholder="" bind:value={searchParam.searchKeyword}
                                on:keydown={(e) => {
                                    if (e.key === 'Enter') {
                                    e.preventDefault();
                                    search();
                                    }
                                }}
                        >
                    </label>
                </fieldset>

            </form>
        </article>
        <article class="form-block ml-12">
            <p class="form-block__title">기간 검색</p>
            <form action="" class="d-flex align-center ml-5 gap-3">
                <fieldset>
                    <legend>input style default input 달력</legend>
                    <div class="d-flex align-items-center flex-row js-datepicker-range" style="height: 40px;">
                    <div class="ui-form-block h-100">
                        <input
                        type="text"
                        class="input-field h-100 js-datepicker-range__min"
                        title="시작 날짜"
                        use:datepickerRange={{ type: 'start', ref: startRef }}
                        />
                    </div>
                    <span class="el-hyphen d-flex align-center mx-3">~</span>
                    <div class="ui-form-block h-100">
                        <input
                        type="text"
                        class="input-field h-100 js-datepicker-range__max"
                        title="종료 날짜"
                        use:datepickerRange={{ type: 'end', ref: endRef }}
                        />
                    </div>
                    </div>
                </fieldset>
                <fieldset class="width-80">
                    <legend>요일 input 셀렉트</legend>
                    <div class="custom-select w-100" class:active={isDatePresetOpen} bind:this={datePresetDropdownEl}>
                         <button type="button" class="custom-select__selected" on:click={toggleDataPresetDropdown}>
                            <span>{viewDataPreset}</span>
                            <i class="icon icon-dropdown"></i>
                        </button>
                        <ul class="custom-select__options">
                            {#each datePresetOptions as option}
                            <li class="custom-select__option">
                                <button
                                    type="button"
                                    class="custom-select__button"
                                    on:click={() => selectDatePreset(option)}
                                    >
                                    {option.label}
                                </button>
                            </li>
                            {/each}
                        </ul>
                    </div>
                </fieldset>
            </form>
        </article>
        <article class="form-block ml-12">
            <p class="form-block__title">상태</p>
             <form action="" class="d-flex align-center flex-wrap gap-3 ml-5">
                {#each statusOptions as option, index}
                <fieldset class={index > 0 ? 'ml-5' : ''}>
                    <legend>1:1문의 상태 input 라디오</legend>
                    <div class="custom-radio inline-text">
                    <input
                        type="radio"
                        name="radio-inquiry"
                        id={"input-field-adminRadio" + (index + 1)}
                        bind:group={status}
                        value={option.value}
                        checked={option.checked}
                        title="default input 라디오"
                    />
                    <label for={"input-field-adminRadio" + (index + 1)}>
                        {option.label}
                    </label>
                    </div>
                </fieldset>
                {/each}
            </form>
        </article>
        <article class="form-block ml-auto">
            <button type="button" class="btn btn-reset" aria-label="reset" on:click={searchBoxReset}>
                <i class="icon icon-reset"></i>
            </button>
            <button type="button" class="btn bg-darkgray height-40 ml-1" on:click={search}>조회</button>
        </article>
    </section>
    <div class="d-flex gap-8 h-100 mt-6">
        <div class="flex-1 h-100">
            <div class="d-flex align-center mt-5">
                <p class="table-count">
                    총 <span>{total}</span> 건
                </p>
            </div>
            <div class="d-flex flex-column mt-2 bg-white box-border" style="height:calc(100% - 11rem)">
                <div class="table-wrap">
                <table class="table-basic table-basic-serviceHistory">
                    <caption></caption>
                    <colgroup>
                        <col style="width:7%">
                        <col style="width:15%">
                        <col style="width:auto">
                        <col style="width:15%">
                        <col style="width:15%">
                        <col style="width:20%">
                    </colgroup>
                    <thead>
                    <tr>
                        <th scope="col">번호</th>
                        <th scope="col">진행 상태</th>
                        <th scope="col">처리 유형</th>
                        <th scope="col">사용자 ID</th>
                        <th scope="col">사용자 이름</th>
                        <th scope="col">등록 일시</th>
                    </tr>
                    </thead>
                     <tbody>
                        {#if loading}
                        <tr>
                            <td colspan="6" class="text-center">로딩 중...</td>
                        </tr>
                        {:else if error}
                        <tr>
                            <td colspan="6" class="text-center text-red">{error}</td>
                        </tr>
                        {:else if serviceHistories.length === 0}
                        <tr>
                            <td colspan="6" class="text-center">등록된 플랜이 없습니다.</td>
                        </tr>
                        {:else}
                            {#each serviceHistories as history, index}
                            <tr>
                                <td>{index+1}</td>
                                <td>
                                    <button
                                    type="button"
                                    class="btn {history.status === '에러' ? 'btn-error' : 'btn-comp'}"
                                    >
                                    {history.status === '에러' ? '에러' : '완료'}
                                    </button>
                                </td>
                                <td>{history.history_type}</td>
                                <td>{history.user_id}</td>
                                <td>{history.user_name}</td>
                                <td>{history.timestamp}</td>
                            </tr>
                            {/each}
                        {/if}
                    </tbody>
                </table>
            </div>
            </div>
            <Pagination {currentPage} {totalPages}  pageChange={handlePageChange}></Pagination>
        </div>
        <div class="d-flex flex-column flex-1 h-100">
            <p class="font-16 font-weight-700">상세 정보</p>
            <div class="tab-wrap flex-1 mt-5">
                <div class="tab-link">
                   <button
                        type="button"
                        class:is-active={activeTab === 'request'}
                        on:click={() => (activeTab = 'request')}
                    >
                        요청내용
                    </button>
                    <button
                        type="button"
                        class:is-active={activeTab === 'response'}
                        on:click={() => (activeTab = 'response')}
                    >
                        응답내용
                    </button>
                </div>
                <div class="tab-contWrap">
                {#if activeTab === 'request'}
                    <div class="tab-cont is-active">
                    <div class="request-detail">
                        <ul class="detail-list">
                        <li><strong>요청 ID:</strong> #req-20250617-00042</li>
                        <li><strong>요청자:</strong> leejunho (이준호)</li>
                        <li><strong>요청 일시:</strong> 2025-06-17 08:59:00</li>
                        <li><strong>처리 유형:</strong> PDF 변환 요청</li>
                        <li><strong>문제 수:</strong> 25문제</li>
                        <li><strong>선택 프롬프트:</strong> 객관식 오지선다 문제 생성</li>
                        <li><strong>요청 파라미터:</strong>
                            <pre class="code-block">{paramsExample}</pre>
                        </li>
                        </ul>
                    </div>
                    </div>
                {:else if activeTab === 'response'}
                    <div class="tab-cont is-active">
                    <div class="response-detail">
                        <ul class="detail-list">
                        <li><strong>응답 일시:</strong> 2025-06-17 09:00:00</li>
                        <li><strong>진행 상태:</strong> <span class="status-error">에러</span></li>
                        <li><strong>응답 코드:</strong> 504 (Gateway Timeout)</li>
                        <li><strong>응답 메시지:</strong> 변환 처리 중 타임아웃이 발생했습니다.</li>
                        <li><strong>결과 파일:</strong> 없음 (에러 발생)</li>
                        </ul>
                    </div>
                    </div>
                {/if}
                </div>
            </div>
        </div>
    </div>
</div>


<style>
  .code-block {
        font-size: 14px !important;
    }

  .request-detail {
    padding: 1rem;
    background-color: #fafafa;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    font-size: 14px;
    color: #333;
    margin-top: 1rem;
  }
  .response-detail {
    padding: 1rem;
    background-color: #fafafa;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    font-size: 14px;
    color: #333;
    margin-top: 1rem;
  }
  .detail-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .detail-list li {
    margin-bottom: 0.75rem;
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 0.5rem;
  }

  .detail-list strong {
    display: inline-block;
    width: 130px;
    color: #555;
  }

  .code-block {
    display: block;
    margin-top: 0.5rem;
    background-color: #f5f5f5;
    padding: 0.8rem;
    border-radius: 4px;
    font-family: 'Courier New', monospace;
    font-size: 13px;
    color: #333;
    white-space: pre-wrap;
    word-break: break-all;
    border: 1px solid #ddd;
  }

  .status-error {
    color: #e53935;
    font-weight: bold;
  }
</style>